export default __webpack_public_path__ + "static/media/certik.7bd8cf24.png";